import {
  getActualSnowBrktPerSqr,
  getHorizontalEaveSpacing,
  getHorizontalFieldSpacing,
  getNumOfCourses,
  getSafetyfactor,
  getSnowBrktPerSqr,
  getTotalNumOfBracket,
  getVerticalSpacing
} from './calculations';
import { DropdownNames, getBracketImageWithPrice } from './calculatorUtils';

export const inputFeildsObj = {
  'Ground Snow Load': {
    key: 'Ground Snow Load',
    name: 'groundSnowLoad',
    label: 'Ground Snow Load (Per Square Foot):',
    required: true,
    min: 1,
    max: 700,
    maxLength: 3
  },

  'Rain Load': {
    key: 'Rain Load',
    name: 'rainLoad',
    label: 'Rain Load (Per Square Foot) - Canada Only:',
    required: false,
    min: 1.1,
    max: 99,
    maxLength: 3
  },

  'Roof Pitch / Slope': {
    key: 'Roof Pitch / Slope',
    name: 'roofSlope',
    label: 'Roof Slope/Pitch (X:12):',
    required: true,
    min: 1,
    max: 18,
    maxLength: 2
  },

  'Vertical Exposure of Product': {
    key: 'Vertical Exposure of Product',
    name: 'verticalExposure',
    label: 'Vertical Exposure of Roofing Product (in):',
    required: false,
    min: 3,
    max: 120,
    maxLength: 3
  },
  'Horizontal Exposure of Product': {
    key: 'Horizontal Exposure of Product',
    name: 'horizontalExposure',
    label: 'Horizontal Exposure (ie: Panel Width) (in):',
    required: false,
    min: 2,
    max: 45,
    maxLength: 2
  },
  'Number of Roofing Squares': {
    key: 'Number of Roofing Squares',
    name: 'numberOfRoofingSqrs',
    label: 'Number of Roofing Squares:',
    required: true,
    min: 1,
    max: 200,
    maxLength: 3
  }
};

// functions

/**
 * check for errors in input values
 *
 * @param {string} name
 * @param {number} value
 * @returns
 */
export const handleInputValidation = (name, value, min, max, handleError) => {
  if (isNaN(value)) {
    handleError(name, ' is required');
  }
  if (!isNaN(max)) {
    if (value > max) {
      handleError(name, 'enter value less than or equal ' + max);
      return true;
    }
  }
  if (!isNaN(min)) {
    if (value < min) {
      handleError(name, 'enter value greater than or equal to ' + min);
      return true;
    }
  }
  return false;
};

export const getCalcuations = (dropdowns, inputs, strength, setOutputs) => {
  const useHorizontal = ['Standing Seam', 'Metal Panel', 'Corrugated Metal'].includes(
    dropdowns[DropdownNames.roofType]
  );
  const useVertical = [
    'Asphalt Shingles',
    'Wood Shakes',
    'Simulated Slate',
    'Slate',
    'Granule Metal',
    'Cedar Shingles',
    'Flat Seam Metal',
    'Metal Shingles'
  ].includes(dropdowns[DropdownNames.roofType]);
  // console.log('getSafetyfactor', getSafetyfactor(dropdowns[DropdownNames.roofType]));
  // console.log(
  //   'args of tist func------------',
  //   parseFloat(inputs?.groundSnowLoad?.value),
  //   parseFloat(inputs?.rainLoad?.value || 0),
  //   parseFloat(inputs?.roofSlope?.value),
  //   strength,
  //   getSafetyfactor(dropdowns[DropdownNames.roofType])
  // );
  const reqSnowBrktPerSqrArg = getSnowBrktPerSqr(
    parseFloat(inputs?.groundSnowLoad?.value),
    parseFloat(inputs?.rainLoad?.value || 0),
    parseFloat(inputs?.roofSlope?.value),
    strength,
    getSafetyfactor(dropdowns[DropdownNames.roofType])
  );
  // console.log('reqSnowBrktPerSqrArg------------', reqSnowBrktPerSqrArg);
  const commonArgs = [
    parseFloat(inputs?.horizontalExposure?.value || 0),
    parseFloat(inputs?.verticalExposure?.value || 0),
    parseFloat(reqSnowBrktPerSqrArg),
    useHorizontal, //useHorizontal
    useVertical, // useVertical
    dropdowns[DropdownNames.roofType] === 'Concrete/Clay Tile',
    dropdowns[DropdownNames.roofType] === 'Single-Ply'
  ];

  // console.log('common args -------------', commonArgs);

  const verticalSpacing = getVerticalSpacing(...commonArgs);
  // console.log('verticalSpacing', verticalSpacing);

  const horizontalFieldSpacing = getHorizontalFieldSpacing(...commonArgs);
  // console.log('horizontalFieldSpacing', horizontalFieldSpacing);
  const actualSnowBracketPerSquare = getActualSnowBrktPerSqr(
    horizontalFieldSpacing,
    verticalSpacing
  );
  // console.log('actualSnowBracketPerSquare', actualSnowBracketPerSquare);
  const horizontalEaveSpacing = getHorizontalEaveSpacing(horizontalFieldSpacing);
  // console.log('horizontalEaveSpacing', horizontalEaveSpacing);

  const numOfCoursesHorizontalAtEave = getNumOfCourses(
    horizontalEaveSpacing,
    inputs.horizontalExposure?.value
  );
  // console.log('numOfCoursesHorizontalAtEave', numOfCoursesHorizontalAtEave);
  const numOfCoursesVertically = getNumOfCourses(verticalSpacing, inputs.verticalExposure?.value);
  // console.log('numOfCoursesVertically', numOfCoursesVertically);
  const totalBracketsForRoofingSquares = getTotalNumOfBracket(
    inputs?.numberOfRoofingSqrs?.value,
    actualSnowBracketPerSquare
  );

  setOutputs({
    reqSnowBrktPerSqrArg,
    actualSnowBracketPerSquare,
    horizontalEaveSpacing,
    horizontalFieldSpacing,
    verticalSpacing,
    numOfCoursesHorizontalAtEave,
    numOfCoursesVertically,
    totalBracketsForRoofingSquares
  });
  return {
    actualSnowBracketPerSquare,
    numOfCoursesHorizontalAtEave,
    numOfCoursesVertically
  };
};

export const getIsSnowBracket = (currentOptions) => {
  if (currentOptions?.length > 0) return currentOptions[0]?.label == 'Snow Bracket Type';
  return false;
};

export const isValidNumber = (value) => {
  return !(isNaN(value) || value === '' || value === Infinity || value === -Infinity);
};

export const getAreRoofingSqrsValid = (roofingSquares) => {
  if (
    isValidNumber(roofingSquares) &&
    roofingSquares >= inputFeildsObj['Number of Roofing Squares'].min &&
    roofingSquares <= inputFeildsObj['Number of Roofing Squares'].max
  ) {
    return true;
  }
  return false;
};

export const getPrices = (selectedImages, bracketImagesWithPrices, numberOfBrackets) => {
  const bracketData = selectedImages?.filter(
    (image) => image?.label === 'Snow Bracket Type' || image?.label === 'Snow Bracket Material'
  );
  const pricedBracket = getBracketImageWithPrice(selectedImages, bracketImagesWithPrices);
  const material = pricedBracket?.materials?.find(
    (material) => material?.material === bracketData[1]?.title
  );
  const unitPrice = material?.price;
  const totalPrice = unitPrice * Math.ceil(numberOfBrackets);
  return {
    unitPrice,
    totalPrice
  };
};

export const deleteExtraDropDowns = (map, level) => {
  for (const mapKey of map.keys()) {
    if (mapKey > level) {
      map.delete(mapKey);
    }
  }
};
